"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentContainer = void 0;
const lodash_1 = require("lodash");
const React = require("react");
const ComponentPreview_1 = require("./ComponentPreview");
const ComponentProps_1 = require("./ComponentProps");
const ComponentContainer = ({ documentation: { examples }, name = '', properties, renderExample, }) => {
    const headerId = `header-${(0, lodash_1.kebabCase)(name)}`;
    return (React.createElement("div", null,
        React.createElement("h3", { id: headerId }, name),
        React.createElement(ComponentPreview_1.ComponentPreview, { examples: examples, renderExample: renderExample }),
        React.createElement(ComponentProps_1.ComponentProps, { properties: properties })));
};
exports.ComponentContainer = ComponentContainer;
//# sourceMappingURL=ComponentContainer.js.map